import { Text } from "@mantine/core";

import { useSelector } from "../../redux/hooks";

const EntryText = () => {
  const {
    lbentry: { entryText },
  } = useSelector(state => state.generatorSlice);
  return (
    <Text color="gray" size={14}>
      {entryText ?? ""}
    </Text>
  );
};
export default EntryText;
